import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { MdKeyboardArrowLeft } from 'react-icons/md';
import APModal from 'components/Modal/APModal';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import getBodyElement from 'utils/getBodyElement';
import './prep-mode.scss';

function createPortalRoot() {
  const root = document.createElement('div');
  root.setAttribute('id', 'prep-mode-root');
  return root;
}

const PrepMode = ({
  message,
  actionText,
  action,
  confirmationText,
  confirmationButtonText,
}) => {
  const [isOpen, setIsOpen] = useState(localStorage.getItem('prep-mode') !== 'false');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const bodyRef = useRef(getBodyElement());
  const portalRootRef = useRef(document.getElementById('prep-mode-root') || createPortalRoot());

  useEffect(() => {
    if (document.getElementById('prep-mode-root') === null) {
      bodyRef.current.appendChild(portalRootRef.current);
    }
    else {
      portalRootRef.current = document.getElementById('prep-mode-root');
    }

    const portal = portalRootRef.current;

    return () => {
      portal.remove();
    };
  }, []);

  useEffect(() => {
    localStorage.setItem('prep-mode', isOpen);
  }, [isOpen]);

  return createPortal(
    <>
      <div className={clsx('prep-mode', `${isOpen ? 'show' : ''}`)}>
        <div className="prep-mode__content">
          <p className="prep-mode__text">{message}</p>
          <button
            className="prep-mode__action"
            onClick={() => setIsModalOpen(true)}
          >
            {actionText}
          </button>
        </div>
        <div
          className="prep-mode__collapse-btn"
          onClick={() => setIsOpen(!isOpen)}
        >
          Prep mode
          <MdKeyboardArrowLeft size={14} />
        </div>
      </div>
      {isModalOpen && (
        <APModal
          open={isModalOpen}
          className="ap-modal--confirm prep-mode-confirm"
          onClose={() => setIsModalOpen(false)}
          size="xs"
          hasHeader={false}
          actions={(
            <>
              <button
                type="button"
                className="button-cancel button"
                onClick={() => setIsModalOpen(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="button-delete button"
                onClick={(e) => {
                  e.stopPropagation();
                  action();
                  setIsModalOpen(false);
                }}
              >
                {confirmationButtonText}
              </button>
            </>
          )}
        >
          {confirmationText}
        </APModal>
      )}
    </>,
    portalRootRef.current,
  );
};

PrepMode.propTypes = {
  message: PropTypes.string,
  actionText: PropTypes.string,
  action: PropTypes.func,
  confirmationText: PropTypes.string,
  confirmationButtonText: PropTypes.string,
};

export default PrepMode;
